<template>
	<!-- 页脚 -->
	<footer>
		<div class="container">
			<div class="footer-content">
				<div class="footer-column">
					<h3>关于我们</h3>
					<p>深圳市鹏峰财税有限责任公司是一家专业的财税服务机构，致力于为企业提供全方位、专业化的财税解决方案。</p>
					<div class="social-links">
						<a href="#"><i class="fab fa-weixin"></i></a>
						<a href="#"><i class="fab fa-weibo"></i></a>
						<a href="#"><i class="fab fa-linkedin-in"></i></a>
					</div>
				</div>
				<div class="footer-column">
					<h3>快速链接</h3>
					<ul class="footer-links">
						<li><a href="#">首页</a></li>
						<li><a href="#">服务项目</a></li>
						<li><a href="#">关于我们</a></li>
						<li><a href="#">新闻资讯</a></li>
						<li><a href="#">常见问题</a></li>
					</ul>
				</div>
				<div class="footer-column">
					<h3>服务项目</h3>
					<ul class="footer-links">
						<li><a href="#">代理记账</a></li>
						<li><a href="#">税务审计</a></li>
						<li><a href="#">财务咨询</a></li>
						<li><a href="#">公司注册</a></li>
						<li><a href="#">财税培训</a></li>
					</ul>
				</div>
				<div class="footer-column">
					<h3>联系我们</h3>
					<ul class="contact-info">
						<li>
							<i class="fas fa-map-marker-alt"></i>
							<span>深圳市宝安区西乡街道凤凰岗路信达商务大厦507</span>
						</li>
						<li>
							<i class="fas fa-phone"></i>
							<span>134-2896-8312</span>
						</li>
						<li>
							<i class="fas fa-envelope"></i>
							<span>llfboy@linkji.com</span>
						</li>
						<li>
							<i class="fas fa-clock"></i>
							<span>周一~周五 9:00-18:00</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="footer-bottom">
			<div class="container">
				<p>COPYRIGHT (©) 2018-2025 - 深圳市鹏峰财税有限责任公司</p>
				<p>备案：<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022131677号-1</a></p>
			</div>
		</div>
	</footer>
</template>


<script>
	var _hmt = _hmt || [];
	(function() {
		var hm = document.createElement("script");
		hm.src = "https://hm.baidu.com/hm.js?8eb30d8947106b1767861070e80bf72a";
		var s = document.getElementsByTagName("script")[0];
		s.parentNode.insertBefore(hm, s);
	})();
</script>


<style>
</style>